import { Component, Inject, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HomeController } from '../../../controllers/home/home.controller';
import { PartnerDetailComponent } from '../../link/detail/partner.detail.component';
import { UserRegisterWizardDto } from '@shared/src/dtos/register/UserRegisterWizardDto';

@Component({
  selector: 'register-your-regular-carrier',
  templateUrl: './register-your-regular-carrier.component.html',
  styleUrls: ['./register-your-regular-carrier.component.scss']
})
export class RegisterYourRegularCarrierComponent implements OnInit {

  public generalClass: string = "desktop";

  public registerFormGroup: FormGroup;

  constructor(@Inject('HomeController') protected homecontroller: HomeController, private fb: FormBuilder) {
    if (this.homecontroller.getPlatform)
      this.generalClass = this.homecontroller.getPlatform();

      this.registerFormGroup = PartnerDetailComponent.buildFromRegularCarrier(this.fb);
  }

  ngOnInit() { }
  
    @Output()
    public onClickNext: EventEmitter<UserRegisterWizardDto> = new EventEmitter();
  
    @Input()
    public registerData: UserRegisterWizardDto = new UserRegisterWizardDto;
  
    @Input() 
    public pendigResponse: boolean;
  
    next() {
      if(this.pendigResponse)
        return;
      this.onClickNext.next(this.registerData);
    }
  
    public pretty(value: any): string {
      return JSON.stringify(value);
    }
}
